import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { UserLeaveAllocation, UserLeaveAllocationCreate } from '../interfaces/leave.interface';

export const LeaveAllocationService = {
    getAllocationsByInstitutionAndFiscalYear: async (fiscalYear: number): Promise<UserLeaveAllocation[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(
            ENDPOINTS.USER_LEAVE_ALLOCATION.BY_INSTITUTION_AND_FISCAL_YEAR(institutionId, fiscalYear), {
                headers: AuthService.getAuthHeader()
            });
        return response.data;
    },

    createOrUpdate: async (data: UserLeaveAllocationCreate): Promise<UserLeaveAllocation> => {
        data.institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.USER_LEAVE_ALLOCATION.BASE, data, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    deleteAllocation: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.USER_LEAVE_ALLOCATION.DELETE(id), {
            headers: AuthService.getAuthHeader()
        });
    }
};
